var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 12,
    viewBox: "0 0 44 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6667 6C32.6667 8.94552 35.0545 11.3333 38 11.3333C40.9455 11.3333 43.3333 8.94552 43.3333 6C43.3333 3.05449 40.9455 0.66667 38 0.66667C35.0545 0.66667 32.6667 3.05448 32.6667 6ZM-8.74228e-08 7L3.16667 7L3.16667 5L8.74228e-08 5L-8.74228e-08 7ZM9.5 7L15.8333 7L15.8333 5L9.5 5L9.5 7ZM22.1667 7L28.5 7L28.5 5L22.1667 5L22.1667 7ZM34.8333 7L38 7L38 5L34.8333 5L34.8333 7Z",
    fill: "#1573FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.5fe33085cde469f14bc240de137591d6.svg";
export { ForwardRef as ReactComponent };